<template>
    <section class="section-wrapper section_hero pt-0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-12">
                    <div class="groupon-hero d-none d-md-block">
                        <img
                            class="img-fluid"
                            src="https://res.cloudinary.com/ilovekickboxing/image/upload/f_auto,fl_lossy,q_auto:eco/v1/Sub_Site/Groupon/Groupon_Landing_Page_-_Desktop_Banner_-_2022_e4bqcb.jpg"
                            alt="iLoveKickboxing Groupon Image Mobile"
                        />
                    </div>
                    <div class="groupon-hero d-block d-md-none">
                        <img
                            class="img-fluid"
                            src="https://res.cloudinary.com/ilovekickboxing/image/upload/f_auto,fl_lossy,q_auto:eco/v1/Sub_Site/Groupon/Groupon_Landing_Page_-_Mobile_Banner_-_2022_zxvjvr.jpg"
                            alt="iLoveKickboxing Groupon Image Mobile"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>